export default __webpack_public_path__ + "static/media/gargamel.9e1c11fc.png";